/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_TitleInputs */

const en_common_sign_password_title = /** @type {(inputs: Common_Sign_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const zh_common_sign_password_title = /** @type {(inputs: Common_Sign_Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Common_Sign_Password_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_password_title = /** @type {((inputs?: Common_Sign_Password_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_password_title(inputs)
	return zh_common_sign_password_title(inputs)
});
export { common_sign_password_title as "common.sign.password_title" }